import React, {createContext} from "react";
import {APIContext} from "./api_hook";
import {TestGroup, ThumbnailTitleTest} from "context/models";
// Creating the context
export const TestContext = createContext<any>(null);

type TestContextType = {
    // Add the types of the context here
    children: React.ReactNode;
};


const TestProvider = (props: TestContextType) => {
    const results_per_page = 8;
    const {children} = props;
    const {fetch_api} = React.useContext(APIContext);
    const [tests, setTests] = React.useState<ThumbnailTitleTest[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [pauseLoading, setPauseLoading] = React.useState<boolean>(false);
    const [deleteLoading, setDeleteLoading] = React.useState<boolean>(false);
    const [stopLoading, setStopLoading] = React.useState<boolean>(false);
    const [restartLoading, setRestartLoading] = React.useState<boolean>(false);
    const getTests = async () => {
        setLoading(true);
        const options = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const resp = await fetch_api("/api/test/", options);
        const {tests} = resp;
        // console.log({tests})
        setTests(tests);
        setLoading(false);
        return tests;
    };

    const getTest = async (test_id: string) => {
        setLoading(true);
        const options = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const resp = await fetch_api(`/api/test/${test_id}/`, options);
        setLoading(false);
        return resp;
    };


    React.useEffect(() => {
        getTests();
    }, []);


    const [testgroups, setTestGroup] = React.useState<TestGroup[]>([]);

    const getTestGroups = async (search_query: string | null, page: number | null, additional_query_params: any) => {
        let query_params = {
            results_per_page: results_per_page.toString(),
            search_query: "",
            page: "",
            ...additional_query_params
        };
        // console.log({search_query, page})
        if (search_query !== null && search_query.toString().trim() !== "") {
            // console.log("searching")
            query_params = {...query_params, search_query}
        }
        if (page !== null) {
            query_params = {...query_params, page: page.toString()}
        }
        console.log("Testgroups Query:")
        console.log({query_params})
        setLoading(true);
        const options = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        const resp = await fetch_api("/api/testgroup/?" + new URLSearchParams(query_params), options);
        // setTestGroup(resp);
        setLoading(false);
        return resp;
    }

    const deleteTestGroup = async (testgroup_id: string) => {
        setDeleteLoading(true);
        const body = {
            'testgroup_id': testgroup_id,
        };
        const options = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        };

        // console.log("Testgroup ID Options:")
        // console.log(body)
        // console.log(options)
        const resp = await fetch_api(`/api/delete_test/`, options);
        setDeleteLoading(false);
        setTestGroup((testgroups: any[]) => testgroups.filter((tg: any) => tg && tg.id !== testgroup_id));
        return resp;
    }

    const pauseTestGroup = async (testgroup_id: string) => {
        setPauseLoading(true);
        const body = {
            'testgroup_id': testgroup_id,
        };
        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        };
        // console.log("Testgroup ID Options:")
        // console.log(options)
        const resp = await fetch_api(`/api/pause_test/`, options);
        setPauseLoading(false);
        return resp;
    }

    const stopTestGroup = async (testgroup_id: string) => {
        setStopLoading(true);
        const body = {
            'testgroup_id': testgroup_id,
        };
        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        };
        // console.log("Stop Testgroup Options:")
        // console.log(options)
        const resp = await fetch_api(`/api/stop_test/`, options);
        setStopLoading(false);
        return resp;
    }

    const restartTestGroup = async (testgroup_id: string) => {
        setRestartLoading(true);
        const body = {
            'testgroup_id': testgroup_id,
        };
        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        };
        // console.log("Pause Testgroup Options:")
        // console.log(options)
        const resp = await fetch_api(`/api/restart_test/`, options);
        setRestartLoading(false);
        return resp;
    }

    const getTestGroup = async (testgroup_id: string) => {
        setLoading(true);
        const options = {
            method: "GET",
        };
        const resp = await fetch_api(`/api/testgroup/${testgroup_id}/`, options);
        setLoading(false);
        return resp;
    }
    React.useEffect(() => {
        // getTestGroups();
    }, []);
    return (
        <TestContext.Provider
            value={{
                loading,
                pauseLoading,
                stopLoading,
                restartLoading,
                deleteLoading,
                tests,
                getTest,
                getTests,
                testgroups,
                getTestGroup,
                getTestGroups,
                deleteTestGroup,
                pauseTestGroup,
                stopTestGroup,
                restartTestGroup,
                results_per_page
            }}
        >
            {children}
        </TestContext.Provider>
    );
};
export default TestProvider;
